// InfoIconButton component
import React from 'react';
import { IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

const InfoIconButton = ({ onMouseEnter, onMouseLeave, isActive }) => {
  return (
    <IconButton
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      sx={(theme) => ({
        color: isActive ? theme.palette.primary.main + 'CC' : '#ACB5BB',
        ':hover': {
          color: theme.palette.primary.main + 'CC',
        },
      })}
    >
      <InfoIcon />
    </IconButton>
  );
};

export default InfoIconButton;
